import { render, staticRenderFns } from "./FrzChamberDispatchTunnelsChamber.vue?vue&type=template&id=5301018c"
import script from "./FrzChamberDispatchTunnelsChamber.vue?vue&type=script&lang=js"
export * from "./FrzChamberDispatchTunnelsChamber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports